import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Button, {
  ButtonSizes,
  ButtonTypes,
} from '@lib/components/Button/Button';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import Typography from '@lib/components/Typography/Typography';
import { OrderingState, PaginationState } from '@lib/enums/urls';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import { AiUsageByUserItem } from '../utils/types';
import AiUsageTopUsersTable from './AiUsageTopUsersTable';
import styles from '../CompanyPlan.module.scss';

export interface TopUsersSectionProps {
  hasTopUsers: boolean;
  onViewAll: () => void;
  topUsersCollection: AiUsageByUserItem[];
  topUsersLoading: boolean;
  topUsersOrderingState: OrderingState;
  topUsersPaginationState: PaginationState;
}

export default function TopUsersSection({
  hasTopUsers,
  onViewAll,
  topUsersCollection,
  topUsersLoading,
  topUsersOrderingState,
  topUsersPaginationState,
}: TopUsersSectionProps) {
  const { t } = useTranslation();

  return (
    <div className={entityViewStyles.infoItem}>
      <p className={entityViewStyles.infoItemLabel}>
        <MaterialIcon icon="person" symbolsOutlined />
        <Typography variant="caption">
          {t('top-5-users-by-ai-usage')}
        </Typography>
      </p>
      {hasTopUsers ? (
        <div
          className={classNames(
            entityViewStyles.infoItemContent,
            styles.topUsersActions,
          )}
        >
          <Button
            buttonSize={ButtonSizes.small}
            buttonText={t('view-all')}
            buttonType={ButtonTypes.primaryOutlined}
            data-test-id="company-plan__view-all-usage-button"
            onClick={onViewAll}
          />
        </div>
      ) : (
        <div className={entityViewStyles.infoItemContent}>
          <Typography variant="body">-</Typography>
        </div>
      )}
      {hasTopUsers && (
        <div className={entityViewStyles.infoItemMessage}>
          <AiUsageTopUsersTable
            collection={topUsersCollection}
            loading={topUsersLoading}
            orderingState={topUsersOrderingState}
            paginationState={topUsersPaginationState}
          />
        </div>
      )}
    </div>
  );
}
